import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import WhyUs from "@/components/site/WhyUs";
import AreasCovered from "@/components/site/AreasCovered";
import About from "@/components/site/About";
import Pricing from "@/components/site/Pricing";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";
import { useNavigate } from "react-router-dom";

export default function HomePage() {
  const navigate = useNavigate();

  const goToCheckout = (loadKey) => {
    const qs = loadKey ? `?load=${encodeURIComponent(loadKey)}` : "";
    navigate(`/checkout${qs}`);
  };

  return (
    <div className="min-h-screen bg-[var(--kay-bg)] text-[var(--kay-black)]">
      <Navbar />
      <main>
        <Hero onBookClick={() => goToCheckout(null)} />
        <WhyUs />
        <AreasCovered />
        <About />
        <Pricing />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
